import Http from '@/services/httpAcademy'

export const listCertificateTemplates  = (params) => Http.get('/admin/certificates/templates', { params })
export const createCertificateTemplate = (data)   => Http.post('/admin/certificates/templates', data)
export const updateCertificateTemplate = ({ id, ...data }) => Http.patch(`/admin/certificates/templates/${id}`, data)
export const deleteCertificateTemplate = (id)     => Http.delete(`/admin/certificates/templates/${id}`)
export const listIssuedCertificates    = (params) => Http.get('/admin/certificates/issued', { params })
export const issueCertificate          = (data)   => Http.post('/admin/certificates/issue', data)
export const regenerateCertificatePdf  = (id)     => Http.post(`/admin/certificates/${id}/regenerate-pdf`)
export const previewCertificate        = (id)     => Http.get(`/admin/certificates/${id}/preview`)
export const searchCertificateUsers    = (q)      => Http.get('/admin/certificates/search-users', { params: { q } })
export const searchCertificateProducts = (q)      => Http.get('/admin/certificates/search-products', { params: { q } })
